<template>
  <div class="user-feedback">
    <!-- //用户反馈 -->
    <el-row class="t-header">
      <el-col :span="8">内容</el-col>
      <el-col :span="6">时间</el-col>
      <el-col :span="6">最新反馈时间</el-col>
      <el-col :span="4">操作</el-col>
    </el-row>
    <el-row class="content" v-if="resultData.list&&resultData.list.length>0" v-loading="tableLoading">
      <el-row class="content-item" v-for="(item,index) in resultData.list" :key="index">
        <el-row class="info">
          <el-col :span="8">{{item.feedback_content}}</el-col>
          <el-col :span="6">{{item.created_at}}</el-col>
          <el-col :span="6">{{item.created_at}}</el-col>
          <el-col :span="4" class="blue cp"><span @click="respondMessage(item,'3')">回复</span></el-col>
        </el-row>
      </el-row>
    </el-row>

    <div class="tc mt40">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="Number(resultData.page)"
        :page-size="Number(resultData.size)"
        layout="total, prev, pager, next"
        :total="Number(resultData.count)"
      ></el-pagination>
    </div>

     <!-- //回复评论和消息推送的弹窗 -->
      <RespondMessage :respondVisible.sync="respondVisible" :resmessage="resmessage" :titleType="titleType"></RespondMessage>
    
  </div>
</template>

<script>
//引入回复评论和回复内容
import  RespondMessage from "../components/respond-message";

//引入混合mixins模式
import user_mixins from "../components/user-mixins";

import {_userFeedbackList } from "@/api/user.js";


export default {
  created() {
    this.userFeedbackList();
  },
  props:{
    user_id:{
      type:String
    }
  },
  mixins:[user_mixins],
  components: {
    RespondMessage
  },
  data() {
    return {
      tableLoading:false,
      search: {
        page:1,
        size:10,
      },
      // name type num money date
      resultData: {
        data: [
          {
            content_text: "怎么下载课件？",
            time: "2019-05-29 18:22:48",
            score_name: "中科慧眼CTO崔峰：双目摄像头如何改变ADAS系统",
            type: "音频",
            re: "在直播间里可以看ppt",
            re_time:"2019-05-29 18:22:48",
            status:"0",
          },
        ]
      }
    };
  },
  methods: {
    //翻页
    handleCurrentChange(val) {
      // this.search.page = val
      // this.initList()
    },
    reply(item) {
      this.privateDialogVisible = true;
    },
      //加载列表
    userFeedbackList(){
      this.tableLoading=true;
      _userFeedbackList({
        params:{
          page:this.search.page,
          size:this.search.size,
          user_id:this.user_id
        }
      }).then(res=>{
        this.tableLoading=false;
        if(res.resultCode==1){
          this.resultData=res.result;
        }else{
          tiis.$message.error(res.errorMsg);
        }
      })
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.user-feedback {
  .t-header {
    margin-top: 20px;
    background-color: @table-bg;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    font-weight: bold;
  }
  .content {
    .content-item {
      .info {
        height: 60px;
        line-height: 60px;
        padding: 0 10px;
        font-weight: 500;
        overflow: hidden;
        }
      &:nth-child(2n){
      background-color: #fefefe;
      }
      &:hover{
      background-color: @table-bg;
      }
    }
  }
}
</style>